import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { CUSTOMER_TESTING_REPORTS } from './routes-names'

export default (): RouteRecordRaw[] => {
  const { market } = useMarketplace()
  const { FF_CUSTOMER_TESTING_REPORTS_ENABLED_COUNTRIES } =
    useRuntimeConfig().public

  return [
    {
      path: 'testing-reports/:orderlinePublicId',
      name: CUSTOMER_TESTING_REPORTS.REPORT,
      component: () =>
        import('~/scopes/customer-testing-reports/pages/CustomerTestingReport/CustomerTestingReport.vue'),
      meta: {
        owners: ['bot-squad-quality-and-pricing'],
        routeExists: () =>
          FF_CUSTOMER_TESTING_REPORTS_ENABLED_COUNTRIES.includes(
            market.countryCode,
          ),
        tracking: { contentGroup: 'Other' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
